export const LIST = "DELEGATE_DEPOSIT_LIST";
export const STORE = "DELEGATE_DEPOSIT_STORE";
export const DROPDOWN = "DELEGATE_DEPOSIT_DROPDOWN";
export const CURRENCY_EXCHANGE = "CURRENCY_EXCHANGE";

export const INIT_DELEGATE_DEPOSIT_INITIAL_LOADING = "INIT_DELEGATE_DEPOSIT_INITIAL_LOADING";
export const SET_DELEGATE_DEPOSIT_INITIAL_LOADING = "SET_MEMBER_SHOW_INITIAL_LOADING";

export const SET_DELEGATE_DEPOSIT_QUOTA_LOCAL_STATE = "SET_DELEGATE_DEPOSIT_QUOTA_LOCAL_STATE";
export const SET_DELEGATE_DEPOSIT_HISTORY_LOCAL_STATE = "SET_DELEGATE_DEPOSIT_HISTORY_LOCAL_STATE";